var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"site-footer text-center"},[(_vm.$store.state.app !== 'consignment-portal')?_c('div',{staticClass:"site-footer__links"},[_c('router-link',{attrs:{"to":"/terms-of-service"}},[_vm._v("Terms of Service")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/privacy-policy"}},[_vm._v("Privacy Policy")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b03b076c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/globals/footer.vue
// module id = null
// module chunks = 